module.exports = __webpack_public_path__ + "media/images/about_company-bg-0a27a7f8.png";